export enum TexasHoldemRules {
  'rules' = 'rules',
  'hands' = 'hands',
}
